var map = {
	"./black/miyu2.png": "4VHT",
	"./blue/miyu2.png": "JhoI",
	"./white/miyu2.png": "qZDZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4fNl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/miyu2\.png$
// module id = 4fNl
// module chunks = 24